module.exports = {
      id: "chinese-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#chinese-usage",
      toString: function () {
        return this.url;
      }
    }